import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";

import { Container, Row } from "react-bootstrap";

import Header from "../../../components/Header";
import Table from "../../../components/Table";

import Main from "../../../components/Main/index";
import SideContainer from "../../../components/SideContainer/styles";
import SideForm from "../../../components/SideForm";
import Input from "../../../components/Input/index";
import Button from "../../../components/Button/index";
import DropdownButton from "../../../components/DropdownButton";
import ModalActions from "../../../components/ModalActions";
import NavTabs from "../../../components/NavTabs";
import search from "../../../assets/icons/search.svg";

import { 
  Legend,
  THead, 
  Th, 
  ThFilterable, 
  Td, 
  Line, 
  Column, 
  Title, 
  InfoTitle, 
  InfoData, 
} from "./styles";

import routes from "../../../routes/plans.routes";

import { plansData } from "../../../data/provisionalData";

import plans from "../../../assets/icons/plans-hover.svg";
import upArrow from "../../../assets/icons/chevron-up.svg";
import downArrow from "../../../assets/icons/chevron-down.svg";
import hint from "../../../assets/icons/hint.svg";
import api from "../../../service/api";
import { IBranch, IPlan } from "./interface";
import SideContainerAnimated from "../../../components/SideContainer";
import { openModal } from "../../../helpers/modalFunctions";
import ModalSuccess from "../../../components/ModalSuccessMessage";
import { toastCreate, toastUpdate } from "../../../utils/notifications/toast";
import { ToastContainer } from "react-toastify";
import moment from "moment";


const PlanPay = () => {
  const [isAddFormVisible, setIsAddFormVisible] = useState(false);
  const [isEditFormVisible, setIsEditFormVisible] = useState(false);
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(1);
  const [errorOnSubmit, setErrorOnSubmit] = useState(false);
  const [errorOnReturnApi, setErrorOnReturnApi] = useState(false);

  const login = useSelector((state: {login: any}) => state.login);
  const history = useHistory();

  const [plansActives, setPlanActives] = useState<Array<any>>([]);
  const [salesPlans, setSalesPlans] = useState<Array<any>>([]);
  const [searchPlans, setSearchPlans] = useState<Array<any>>([]);
  const [selectedPlan, setSelectedPlan] = useState<any>({});
  const [disassociate, setDisassociate] = useState(false);
  const [plan, setPlan] = useState<any>({
    id: "",
    name: "",
    description: ""
  });
  const [refreshTable, setRefreshTable] = useState(true);

  const [searchBranchs, setSearchBranchs] = useState<Array<any>>([]);
  const [branch, setBranch] = useState<IBranch>({});
  const [listBranchs, setListBranchs] = useState<Array<any>>([])
  const [ isLoading, setIsLoading ] = useState(false);
  const owner = useSelector((state: {branchs: any}) => state.branchs);

  const { establishment } = useSelector((state: {establishment: any}) => state.establishment)

  useEffect(() => {
      const getSalesPlans = async () => {
          const {data} = await api.get("/adm/ownerbranch/planos", {
            params: {
              sellerOwner100PayId: login.user.ownersId,
              page: page
            }
          });

          setPage(data.page)
          setMaxPage(data.pageCount)
          setPlanActives(data.Transactions)
          setRefreshTable(false)
      }

      if(refreshTable) {
        getSalesPlans();
      }
  }, [refreshTable]);

  useEffect(() => {
    setRefreshTable(true)
  },[page])

  useEffect(() => {
    const getSalesPlans = async () => {
        const {data} = await api.get("/adm/ownerbranch/planos");

        setSalesPlans(data)
    }

    getSalesPlans();
  }, []);

  useEffect(() => {
    if(login.user.groups.am4a1){
      history.push("/admin/dashboard");
    }
  }, []);

  useEffect(() => {
    setIsLoading(true);
    const getBranchs = async () => {

      const {data} = await api.get("/adm/owner100pay/list", {
        params: {
          id: login.user.owners.id
        }
      });

      setListBranchs(data.Branch);
      setIsLoading(false);
    }

    if(isAddFormVisible) {
      getBranchs();
    }

  }, [isAddFormVisible])

  const openAddForm = () => {
    if (isEditFormVisible !== true) {
      setIsAddFormVisible(true);
    }
  };

  const openEditForm = () => {
    if (isAddFormVisible !== true) {
      setIsEditFormVisible(true);
    }
  };

  const searchForErrors = (errors: Object) => {
    if(errors !== {}){
      setErrorOnSubmit(true)
    } else {
      setErrorOnSubmit(false)
    }
  }

  useEffect(() => {
    const deletePlan = async () => {

      try {
        const { data } = await api.delete("/adm/ownerbranch/planos/delete", {
          params: {
            planBranchIdAdquirente: selectedPlan
          }
        });

        setRefreshTable(true);
        setTimeout(() => toastCreate("deletePlan", "success", 3000, "Plano desassociado com sucesso"), 1000)
      } catch (error) {
        toastCreate("deletePlan", "error", 3000, "Falha ao desassociar o plano");
      } finally {
        setDisassociate(false)
      }
    }

    if(disassociate && selectedPlan){
      deletePlan()
    }
  },[disassociate])

  const tableContentGenerator = () => {
    return plansActives?.map((plan, index) => {
        return(
            <tr key={plan.id} style={{ height: 67 }}>
                <Td>{index += 1}</Td>
                <Td>{plan.br_businessName}</Td>
                <Td>{plan.pl_description}</Td>
                <Td>
                  <DropdownButton 
                      selectedUser={plan}
                      setDisassociate={setDisassociate}
                      setSelectedUser={setSelectedPlan}
                      isDisassociateOptionVisible={true}
                      setIsEditFormVisible={openEditForm}
                      isViewOptionVisible={true}
                      openModal={true} 
                      modalId="#details-plans"
                  />
                </Td>
            </tr>
        )
    });
  };

  const formValidationWithYup = Yup.object().shape({
    planName: Yup.string().required(),
    establishment: Yup.string().required(),
  });

  const openForm = isAddFormVisible || isEditFormVisible;

  return (
    <Container fluid >
      <ToastContainer/>
      <ModalSuccess text="Plano associado com sucesso!"/>
      <Row>
        <ModalActions title="Informações do plano" subtitle={`Última atualização ${moment(selectedPlan.pl_updated_at).format("DD/MM/YYYY")}`} id="details-plans">
          <Title>Dados Principais</Title>
          <Line>
            <Column>
              <InfoTitle>Empresa associada</InfoTitle>
              <InfoData>{selectedPlan?.br_businessName}</InfoData>
            </Column>
            <Column>
              <InfoTitle>Operadora</InfoTitle>
              <InfoData>Zoop</InfoData>
            </Column>
            <Column>
              <InfoTitle>Descrição</InfoTitle>
              <InfoData>{selectedPlan.pl_description}</InfoData>
            </Column>
          </Line>
          <Line>
            <Column>
              <InfoTitle>Data de criação</InfoTitle>
              <InfoData>{moment(selectedPlan.pl_created_at).format("DD/MM/YYYY")}</InfoData>
            </Column>
          </Line>
        </ModalActions>
        <Main
          className={` ${openForm ? "col-d-none column-side-open" : "column-content"}`}
          isFormVisible={isAddFormVisible}
        >
        <Header title="Planos de venda" subTitle="Associe e desassocie planos de venda ao seu sistema." subTitleWidth={182}/>

        <NavTabs tabs={routes}/>

        <Table
          buttonText="Associar a plano"
          isAddFormVisible={isAddFormVisible}
          setIsAddFormVisible={openAddForm}
          showAddButton={true} //login.user.groups.am4a1c
          showExportButton={true} //login.user.groups.am4a1e
          page={page}
          maximumPage={maxPage}
          setPage={setPage}
        >
          <THead>
            <tr>
              <ThFilterable>
                <div>ID</div>
                <div style={{ marginLeft: 3, lineHeight: 0.7 }}>
                  <img src={upArrow} alt="seta para cima" />
                  <br />
                  <img src={downArrow} alt="seta para baixo" />
                </div>
              </ThFilterable>
              <Th>Nome</Th>
              <Th>Descrição</Th>
              <Th></Th>
            </tr>
          </THead>
          <tbody>{tableContentGenerator()}</tbody>
        </Table>
      </Main>

      <SideContainerAnimated isVisible={isAddFormVisible}>
        <SideForm
          title="Associar a um plano"
          icon={plans}
          visible={() => setIsAddFormVisible(false)}
        >
          <Formik
            initialValues={{
              planName: "",
              establishment: "",
            }}
            validationSchema={formValidationWithYup}
            onSubmit={async (values, { resetForm }) => {
              toastCreate("associatePlan", "info", 1000, "Processando");
              
              try {

                const {data} = await api.post("adm/ownerbranch/planos/associate", {
                    "branch100PayId": branch.id,
                    "planName": values.planName,
                    "planId": plan.id,
                    "sellerOwnerPayId": branch.sellerOwnerPayId,
                })
                
                setErrorOnReturnApi(false);
                setRefreshTable(true);
                setPlan({});
                setBranch({});
                resetForm();
                setIsAddFormVisible(false)
                toastUpdate("associatePlan", "success", 3000, "Plano associado com sucesso");
                openModal("exampleModal");
              } catch (error) {
                toastUpdate("associatePlan", "error", 3000, "Falha ao associar o plano");
                setErrorOnReturnApi(true)
              }
            }}
          >
            {({errors, values, initialValues, resetForm}) => {
              initialValues.establishment = branch.businessName as string
              
              return(
                <Form id="form-subscription" style={{ width: "100%", marginTop: 41 }}>
                  <fieldset>
                    <Legend>Dados Principais</Legend>
                    <div className="inputWithIcon">
                      <Input
                        className="inputCustom"
                        placeholder="Plano"
                        type="search"
                        autoComplete="off"
                        style={{borderColor: `${errorOnSubmit && errors.planName ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                        isSearchField={true}
                        setValue={setPlan}
                        searchType="name"
                        searchResults={searchPlans}
                        value={values.planName = plan.name ? plan.name : ""}
                        onChange={(e: any) => {
                            let search = e.target.value.toUpperCase()
                            let result = salesPlans.filter(item => item.invoice_name.toUpperCase().includes(search))
                            
                            setSearchPlans(result)
                            setPlan({
                                name: e.target.value, 
                                description: plan.description,
                                id: plan.id
                            });
                        }}
                      />
                      <img src={search}/>
                    </div>
                    <div className="inputWithIcon">
                      <Input
                        id="establishment"
                        name="establishment"
                        className="inputCustom"
                        placeholder="Estabelecimento"
                        style={{cursor: `${isLoading ? "wait" : "auto"}`, borderColor: `${errorOnSubmit && errors.establishment ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                        type="search"
                        autoComplete="off"
                        isSearchField={true}
                        disabled={isLoading}
                        setValue={setBranch}
                        searchType="branch"
                        searchResults={searchBranchs}
                        value={branch.businessName}
                        onChange={(e: any) => {
                            let search = e.target.value.toUpperCase()
                            let result = listBranchs.filter(item => item.businessName?.toUpperCase().includes(search))
                            
                            setSearchBranchs(result)
                            setBranch({...branch,
                              businessName: e.target.value
                            })
                        }}
                      />
                      <img src={search}/>
                    </div>
                  </fieldset>
                  <Button
                    className="buttonCustom"
                    type="submit"
                    onClick={() => {
                      searchForErrors(errors)
                    }}
                  >
                    Associar
                  </Button>
                </Form>
              )
            }}
            </Formik>
          </SideForm>
        </SideContainerAnimated>
      </Row>
    </Container>
  )
}

export default PlanPay;
